import script from "./AbuseScore.vue?vue&type=script&setup=true&lang=js"
export * from "./AbuseScore.vue?vue&type=script&setup=true&lang=js"

import "./AbuseScore.vue?vue&type=style&index=0&id=f76cb3ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f76cb3ec"]])

export default __exports__